jQuery(document).ready(function($) {

	// Resource Centre AJAX filtering.
	if ($('.hawrc-resource-centre-landing').length && typeof HAWRC_AJAX !== 'undefined') {
		var selectedTopics       = [];
		var selectedFormats      = [];
		var selectedReadingTimes = [];

		function collectFilters() {
			selectedTopics       = [];
			selectedFormats      = [];
			selectedReadingTimes = [];

			// Topics.
			$('.hawrc-sidebar .cards.filter-card').eq(0).find('.hawrc-pill.teal.active').each(function() {
				var termId = $(this).data('term-id');
				if (termId && termId !== 'all-topics') {
					selectedTopics.push(termId);
				}
			});

			// Formats.
			$('.hawrc-sidebar .cards.filter-card').eq(1).find('.hawrc-pill.og-green.active').each(function() {
				var termId = $(this).data('term-id');
				if (termId && termId !== 'all-formats') {
					selectedFormats.push(termId);
				}
			});

			// Reading times.
			$('.hawrc-sidebar .cards.filter-card').eq(2).find('.hawrc-pill.navy.active').each(function() {
				var readingTime = $(this).data('reading-time');
				if (readingTime) {
					selectedReadingTimes.push(readingTime);
				}
			});
		}

		function updatePillSelection($pill, type) {
			var termId = $pill.data('term-id');

			if (type === 'topic') {
				var $container = $('.hawrc-sidebar .cards.filter-card').eq(0);

				if (termId === 'all-topics') {
					$container.find('.hawrc-pill').removeClass('active');
					$pill.addClass('active');
				} else {
					$pill.toggleClass('active');
					$container.find('.hawrc-pill[data-term-id="all-topics"]').removeClass('active');

					if ($container.find('.hawrc-pill.teal.active').length === 0) {
						$container.find('.hawrc-pill[data-term-id="all-topics"]').addClass('active');
					}
				}
			}

			if (type === 'format') {
				var $containerF = $('.hawrc-sidebar .cards.filter-card').eq(1);

				if (termId === 'all-formats') {
					$containerF.find('.hawrc-pill').removeClass('active');
					$pill.addClass('active');
				} else {
					$pill.toggleClass('active');
					$containerF.find('.hawrc-pill[data-term-id="all-formats"]').removeClass('active');

					if ($containerF.find('.hawrc-pill.og-green.active').length === 0) {
						$containerF.find('.hawrc-pill[data-term-id="all-formats"]').addClass('active');
					}
				}
			}
		}

		function renderSelectedFilters() {
			var $container = $('.selected-filters');
			$container.empty();

			// Topic pills (excluding "All").
			$('.hawrc-sidebar .cards.filter-card').eq(0).find('.hawrc-pill.teal.active').each(function() {
				var termId = $(this).data('term-id');
				var label  = $(this).text().trim();

				if (termId && termId !== 'all-topics') {
					var $chip = $('<span/>', {
						'class': 'selected-filter hawrc-pill filter-pill',
						'data-type': 'topic',
						'data-term-id': termId,
						'type': 'span',
						'text': label
					});
					$container.append($chip);
				}
			});

			// Format pills (excluding "All").
			$('.hawrc-sidebar .cards.filter-card').eq(1).find('.hawrc-pill.og-green.active').each(function() {
				var termId = $(this).data('term-id');
				var label  = $(this).clone()
					.children('.term-count').remove().end()
					.text().trim();

				if (termId && termId !== 'all-formats') {
					var $chip = $('<span/>', {
						'class': 'selected-filter hawrc-pill filter-pill',
						'data-type': 'format',
						'data-term-id': termId,
						'type': 'span',
						'text': label
					});
					$container.append($chip);
				}
			});

			// Reading time pills.
			$('.hawrc-sidebar .cards.filter-card').eq(2).find('.hawrc-pill.navy.active').each(function() {
				var readingTime = $(this).data('reading-time');
				var label       = $(this).text().trim();

				if (readingTime) {
					var $chip = $('<span/>', {
						'class':             'selected-filter hawrc-pill filter-pill',
						'data-type':         'reading-time',
						'data-reading-time': readingTime,
						'type':              'span',
						'text':              label
					});
					$container.append($chip);
				}
			});
		}

		function fetchResources(page) {
			collectFilters();

			var sort       = $('#sort-results').val() || 'date_desc';
			var searchTerm = $('#hawrc-search').val() || '';

			$.ajax({
				url: HAWRC_AJAX.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					action:        'hawrc_filter_resources',
					nonce:         HAWRC_AJAX.nonce,
					page:          page || 1,
					sort:          sort,
					topics:        selectedTopics,
					formats:       selectedFormats,
					reading_times: selectedReadingTimes,
					search:        searchTerm
				},
				beforeSend: function() {
					$('.ajax-listings').removeClass('loaded').addClass('loading');
					$('.ajax-loader').addClass('show-loader');
				},
				success: function(response) {
					$('.ajax-listings').removeClass('loading').addClass('loaded');
					$('.ajax-loader').removeClass('show-loader');

					if (response && response.success) {
						if (response.data && typeof response.data.total !== 'undefined') {
							$('.resource-count strong').text(response.data.total);
						}

						if (response.data && response.data.html !== undefined) {
							$('.ajax-listings .inner-grid').html(response.data.html);
						}

						if (response.data && response.data.pagination !== undefined) {
							$('.ajax-listings .pagination').html(response.data.pagination);
						}

						// Re-render selected filter chips after data update.
						renderSelectedFilters();
					}
				},
				error: function(errorThrown) {
					console.log(errorThrown);
				}
			});
		}

		// Initial load (ensures consistent query vs server-side).
		fetchResources(1);

		// Sorting.
		$('#sort-results').on('change', function() {
			fetchResources(1);
		});

		// Search (live as the user types, with a small delay).
		var searchTimeout;
		$('#hawrc-search').on('input', function() {
			clearTimeout(searchTimeout);
			searchTimeout = setTimeout(function() {
				fetchResources(1);
			}, 300);
		});

		// Topic pills.
		$('.hawrc-sidebar').on('click', '.cards.filter-card:first .hawrc-pill', function(e) {
			e.preventDefault();
			updatePillSelection($(this), 'topic');
			fetchResources(1);
		});

		// Format pills.
		$('.hawrc-sidebar').on('click', '.cards.filter-card:eq(1) .hawrc-pill', function(e) {
			e.preventDefault();
			updatePillSelection($(this), 'format');
			fetchResources(1);
		});

		// Reading time pills.
		$('.hawrc-sidebar').on('click', '.cards.filter-card:eq(2) .hawrc-pill', function(e) {
			e.preventDefault();
			$(this).toggleClass('active');
			fetchResources(1);
		});

		// Pagination.
		$('.hawrc-resources-overview').on('click', '.ajax-listings .pagination a', function(e) {
			e.preventDefault();
			var page = $(this).data('page') || 1;
			fetchResources(page);

			$('html, body').animate({
				scrollTop: $('.hawrc-resources-overview').offset().top - 200
			}, 400);
		});

		// Clear all filters.
		$('.filters .clear').on('click', function(e) {
			e.preventDefault();

			// Reset topic pills.
			var $topicContainer = $('.hawrc-sidebar .cards.filter-card').eq(0);
			$topicContainer.find('.hawrc-pill').removeClass('active');
			$topicContainer.find('.hawrc-pill[data-term-id="all-topics"]').addClass('active');

			// Reset format pills.
			var $formatContainer = $('.hawrc-sidebar .cards.filter-card').eq(1);
			$formatContainer.find('.hawrc-pill').removeClass('active');
			$formatContainer.find('.hawrc-pill[data-term-id="all-formats"]').addClass('active');

			// Reset reading time pills.
			var $readingTimeContainer = $('.hawrc-sidebar .cards.filter-card').eq(2);
			$readingTimeContainer.find('.hawrc-pill').removeClass('active');

			// Clear search.
			$('#hawrc-search').val('');

			// Update chips + results.
			renderSelectedFilters();
			fetchResources(1);
		});

		// Removing a single selected filter chip.
		$('.filters').on('click', '.selected-filter', function(e) {
			e.preventDefault();
			var $chip  = $(this);
			var type   = $chip.data('type');
			var termId = $chip.data('term-id');

			if (type === 'topic') {
				var $topicContainer = $('.hawrc-sidebar .cards.filter-card').eq(0);
				$topicContainer.find('.hawrc-pill[data-term-id="' + termId + '"]').removeClass('active');

				if ($topicContainer.find('.hawrc-pill.teal.active').length === 0) {
					$topicContainer.find('.hawrc-pill[data-term-id="all-topics"]').addClass('active');
				}
			}

			if (type === 'format') {
				var $formatContainer = $('.hawrc-sidebar .cards.filter-card').eq(1);
				$formatContainer.find('.hawrc-pill[data-term-id="' + termId + '"]').removeClass('active');

				if ($formatContainer.find('.hawrc-pill.og-green.active').length === 0) {
					$formatContainer.find('.hawrc-pill[data-term-id="all-formats"]').addClass('active');
				}
			}

			if (type === 'reading-time') {
				var readingTime = $chip.data('reading-time');
				$('.hawrc-sidebar .cards.filter-card').eq(2)
					.find('.hawrc-pill[data-reading-time="' + readingTime + '"]')
					.removeClass('active');
			}

			renderSelectedFilters();
			fetchResources(1);
		});

		// Initial chips render to reflect default "All" state (no chips).
		renderSelectedFilters();
	}
});